"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var fetchFactory = require('@mulesoft/anypoint-fetch');
var defaultRequestTimeout = 120000;
function noop() {
  // No operation performed.
}
var logger = {
  debug: noop,
  info: noop,
  error: noop,
  warn: noop
};
var fetchRamlClient = fetchFactory({
  config: {
    circuitBreaker: {
      enabled: false
    },
    timeout: defaultRequestTimeout
  },
  logger: logger
});
function request(data, done) {
  var response;
  var url = data.url;
  if (data.proxy) {
    url = "".concat(data.proxy).concat(url);
  }
  return fetchRamlClient(url, _objectSpread(_objectSpread({}, data), {}, {
    context: {}
  })).then(function (res) {
    response = res;
    return res.json();
  }).then(function (body) {
    var _response = response,
      status = _response.status,
      headers = _response.headers;
    return done(null, {
      body: body,
      statusCode: status,
      headers: headers
    });
  }).catch(function (err) {
    return done(err);
  });
}
module.exports = request;
//# sourceMappingURL=request.js.map